import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import { Card } from '@material-ui/core';
import { colors } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { mainListItems, SecondaryListItems } from '../listItems';
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import logo5 from "../../logo5.png"
import RehabPlanMainComponent from '../data/overview_data.js/RehabPlanMainComponent'
import Treatmentadvices from '../data/treatmentadvice/Treatmentadvice.js';
import recoveryPhases from '../data/recoveryPhases';
import * as AuthActions from "../../../store/actions/auth";
import ReactPlayer from 'react-player'
import RehabPhases from "../data/rehabPhases.js";
import HorizontalScroll from 'react-horizontal-scrolling'
import Skeleton from '@material-ui/lab/Skeleton';
import ExerciseImage from './ExerciseImage';

const useStyles = makeStyles(() => ({
    root: {
        height: '100%'
    },
    avatar: {
        backgroundColor: colors.orange[600],
        height: 50,
        width: 50
    }
}));

const simpleFormatter = (text, len) => {
    var i = 0;
    for(i = 0; i < text.length; i = i+len){
      if (i != 0) {
        const subString = text.slice(0, i).split("").reverse().join(""); // abc d -> d cba
        const splitIndex = subString.length - subString.indexOf(' ');
        text = text.slice(0, splitIndex) + "\n" + text.slice(splitIndex);
      }
    }
    return text;
  }

const CompletedExercises = (props) => {
    const className = props.className

    const classes = useStyles();

    const { innerWidth: width, innerHeight: height } = window;


    const [token, _] = useState(useSelector(state => state.auth.token))

    return (
        <div className={classes.root}>
           <Grid container xs={12} md={12} lg={12} style={{ marginTop: "1%" }}>
                <Typography style={{color: "#002D55", marginBottom: "1%", marginLeft: 20}} variant="h5">
                  Completed exercises of your current session:
                </Typography>
                <Grid container wrap="nowrap" justifyContent="center"> 
                  <HorizontalScroll>
                    {props.completedExercises.map(exercise => (
                      <Box style={{marginTop: "0%", marginRight: "1%", marginBottom: "1%", marginLeft: 25 }}>
                        <ExerciseImage exercise={exercise} height={height * 0.15} skeletonWidth={210} skeletonHeight={118} />
                        
                        {exercise ? (
                          <Box pr={2}>
                            <Typography gutterBottom variant="body2" >
                              <pre style={{ fontFamily: 'inherit' }}>
                                {simpleFormatter(exercise.title, 30)}
                              </pre>
                            </Typography>
                            <Typography display="block" variant="caption" color="textSecondary">
                              {exercise.exerciseType}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {`${exercise.sets} sets • ${exercise.repetitions} repetitions`}
                            </Typography>
                          </Box>
                        ) : (
                          <Box pt={0.5}>
                            <Skeleton /> 
                            <Skeleton width="100%" />
                          </Box>
                        )}
                      </Box>
                    ))}
                  </HorizontalScroll>
                </Grid>
              </Grid>
        </div>
    );
};


export default CompletedExercises;
